import { faCircleInfo as fasCircleInfo } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonLegacy, List } from "@shared/ui";
import type { FormApi } from "final-form";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

type StepFields = {};

export class Step6 extends AbstractStep {
	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		return (
			<>
				<Card.Header>
					<Card.Title className="text-center">
						A számodra elérhető Babaváró hitel részleteit emailben küldjük el neked a következő fontos
						információkkal:
					</Card.Title>
				</Card.Header>
				<Card.Body className="d-flex align-items-center">
					<List itemStyle="tick" variant="gold">
						<List.Item>Mennyi a számodra elérhető hitel összege?</List.Item>
						<List.Item>Mekkora lesz a havi törlesztés?</List.Item>
						<List.Item>Miben térhetnek el egymástól az egyes bankok?</List.Item>
					</List>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						type="submit"
						variant="gold"
						className={!form.getState().valid ? "disabled" : undefined}
						icon={<FontAwesomeIcon icon={fasCircleInfo} />}
					>
						Kérem a részletes eredményeim
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "bg-success"]).join(" ");
	}

	protected getComponentName(): string {
		return "Step6";
	}
}
